module.exports = __webpack_public_path__ + "static/media/a8.da94a50.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dili/a8.mp3
// module id = 6Z0S
// module chunks = 0